import React, { useState } from "react";
import s from "./CarItem.module.scss";
import { useNavigate } from "react-router-dom";
import { getCarDetails } from "../../redux/carSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const CarItem = ({ car }) => {
  const [isHovered, setIsHovered] = useState();
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleDotClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <div
      className={car.urgent ? s.urgentCarItem : s.carItem}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={() => dispatch(getCarDetails(car?.id))}
    >
      <div className={s.img_wrapper}>
        {
          <img
            src={car?.images[0]?.image || "/no-image.png"}
            className={s.car_img}
          />
        }
      </div>
      <div className={s.car_item_price}>$ {Number(car?.price)?.toFixed(0)}</div>
      <div className={s.car_desc}>
        <div>{car?.brand?.name}</div> &nbsp;
        <div>{car?.model?.name}</div>
      </div>
      {car?.urgent ? <div className={s.car_urgent}>{t("urgent")}</div> : null}
      {isHovered ? (
        <div className={s.hovered} onClick={() => navigate(`/car/${car.id}`)}>
          <div className={car.urgent ? "urgentCarousel" : "carousel"}>
            <div
              className='slides'
              style={{ transform: `translateX(-${activeIndex * 100}%)` }}
            >
              {car?.images?.map((image, index) => (
                <div key={index} className='slide'>
                  <img
                    className={s.hoveredImg}
                    src={image.image || "/no-image.png"}
                    alt={`Slide ${index + 1}`}
                  />
                </div>
              ))}
            </div>
            {car?.urgent ? (
              <div className={s.car_urgent2}>{t("urgent")}</div>
            ) : null}

            <div className={s.price}>
              <div>
                <div className={s.price_usd}>
                  ${Number(car?.price)?.toFixed(0)}
                </div>
                &nbsp;
                <div className={s.price_kgs}>{car?.price * 90}c</div>
              </div>

              <div className={s.location}>{car?.location}</div>
            </div>
            <div className={s.brand}>
              <div className={s.car_name}>
                &nbsp;
                {car?.brand?.name} {car?.model?.name}
              </div>
              <div>{car?.year_of_manufacture}</div>
            </div>
            <div className={s.dots}>
              {car?.images?.map((_, index) => (
                <span
                  key={index}
                  className={index === activeIndex ? "dot active" : "dot"}
                  onMouseEnter={() => handleDotClick(index)}
                ></span>
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CarItem;
